<template>
  <div>
    <header>
      <div class="left">
        <h2>Suppliers</h2>
        <p>Manage your suppliers</p>
      </div>

      <!-- <div class="right">
        <a class="main-action">New supplier</a>
      </div> -->
    </header>

    <table class="acada-table orgs">
      <colgroup>
        <col style="width: 250px" />
        <col style="width: 40%" />
        <col style="width: 20%" />
        <col style="width: 20%" />
      </colgroup>

      <tr>
        <th></th>
        <th>Name</th>
        <th>Created</th>
        <th>Prefix</th>
      </tr>

      <tr v-for="supplier of suppliers" :key="supplier.id">
        <td>
          <img :src="supplier.logoUrl" class="img" />
        </td>

        <td>{{ supplier.name }}</td>

        <td>{{ formatDate(supplier.createdAt) }}</td>

        <td>{{ supplier.description }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'Suppliers',
  created() {
    this.getSuppliers();
  },
  computed: {
    ...mapGetters(['suppliers']),
  },
  methods: {
    ...mapActions(['getSuppliers']),
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
  },
};
</script>
